import { Provider as ReduxProvider } from "react-redux";
import { ApolloProvider } from "@apollo/client";
import { lazy, Suspense, useEffect } from "react";

import reduxStore from "./redux/store";
import defaultApolloClient from "./graphql/clients/defaultApolloClient";
import { MetaPixel } from "components/atoms/analytics";
import { useGenerateDeviceID } from "hooks/authorization";
import { initializeGA } from "analytics/googleAnalytics/initiateGoogleAnalytics";

const AppLoadingPage = lazy(() => import("components/pages/AppLoadingPage"));
const AppWrapper = lazy(() => import("AppWrapper"));
const ErrorHandler = lazy(() => import("components/common/ErrorHandler"));

const App: React.FC = () => {
  const { hasUUID } = useGenerateDeviceID();
  const stillPreparing = !hasUUID;

  useEffect(() => {
    initializeGA();
  }, []);

  if (stillPreparing) {
    return <AppLoadingPage />;
  }

  return (
    <ReduxProvider store={reduxStore}>
      <ApolloProvider client={defaultApolloClient()}>
        <MetaPixel />
        <ErrorHandler>
          <Suspense fallback={<AppLoadingPage />}>
            <AppWrapper />
          </Suspense>
        </ErrorHandler>
      </ApolloProvider>
    </ReduxProvider>
  );
};

export default App;
